import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Link, { linkBase } from '@src/mobile/components/Link';

const Page404 = ({ text = '该内容已删除' }) => {
    return (
        <div className={styles.fullScreen}>
            <div className={styles.wrap}>
                <div className={styles.icon} />
                <div className={styles.text}>{text}</div>
                <div>
                    <Link to={`${linkBase}/loc/timeline`}>
                        <div className={styles.btn}>看看其他热点追踪</div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

Page404.propTypes = {
    text: PropTypes.string,
};

export default errorBoundary(Page404);
